import React from "react";
import { Link } from "react-router-dom";

const TermofUse = () => {
  return (
    <>
      <section className="pt-[180px] max-md:pt-[130px] pb-[80px] relative max-lg:bg-[right_center] bg-[#f4f4f4] about-banner overflow-hidden">
        <div className="container">
          <div className="row items-center">
            <div className="w-full">
              <div className="relative max-md:text-center">
                <h2 className="text-[92px] max-md:text-[50px] font-bold capitalize font-sora text-secondary leading-[1.2]">
                  Term & Conditions
                </h2>
                <img
                  src="assets/img/shap-three-1.png"
                  alt="banner-shap"
                  className="absolute w-46 w-35 -top-[30px] -left-[32px] max-md:hidden  animate-topshap"
                />
              </div>
              <ol className="mb-[16px] flex items-center max-md:justify-center max-md:mb-[40px] pt-[20px] max-md:hidden">
                <li className="text-[22px] text-secondary font-sora capitalize">
                  <Link to="/"> Home </Link>
                </li>
                <li
                  className="text-[22px] text-gary capitalize before:content-['-'] before:float-left before:text-gary before:px-[10px]"
                  aria-current="page"
                >
                  Term & Conditions
                </li>
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section id="h4-pricing" className="relative w-full overflow-hidden">
        <div className="w-full h4-pricing-wrapper max-md:px-[30px] pb-[80px] md:pb-[80px] max-md:pt-[60px] md:pt-[80px] pricing_section_bg">
          <div className="theme-container mx-auto">
            <div className="w-full">
              <div className="md:px-[100px]">
                <p className="mb-[10px]">
                  These Terms &amp; Conditions (“Terms”) govern your access to and
                  use of the CurePointOPD website (the “Website”) and the
                  SaaS-based healthtech infrastructure we provide (the “Service”).
                  By accessing or using the Website or Service, you agree to be
                  bound by these Terms.
                </p>
                <p className="mb-[10px]">
                  <strong>1. Definitions</strong>
                </p>
                <div>
                  <p className="mb-[10px]">
                    <strong>“CurePointOPD”</strong> refers to CUREPOINT OPD (OPC) PRIVATE LIMITED, the provider of the Service.
                  </p>
                  <p className="mb-[10px]">
                    <strong>“You”</strong> refers to the individual or entity
                    accessing or using the Website or Service.
                  </p>
                  <p className="mb-[10px]">
                    <strong>“Content”</strong> refers to any information, data,
                    text, software, code, or other materials displayed on or
                    available through the Website or Service.
                  </p>
                  <p className="mb-[10px]">
                    <strong>“User”</strong> refers to any individual or entity who
                    accesses or uses the Website or Service.
                  </p>
                </div>
                <p className="mb-[10px]">
                  <strong>2. Use of the Website and Service</strong>
                </p>
                <div>
                  <p className="mb-[10px]">
                    You may only use the Website and Service for lawful purposes
                    and in accordance with these Terms.
                  </p>
                  <p className="mb-[10px]">You agree not to use the Website or Service:</p>
                  <div style={{ paddingLeft: 10 }}>
                    <p className="mb-[10px]">
                      • In a manner that could damage, disable, overburden, or
                      impair the Website or Service.
                    </p>
                    <p className="mb-[10px]">
                      • To interfere with any other user’s enjoyment of the
                      Website or Service.
                    </p>
                    <p className="mb-[10px]">
                      To gain unauthorized access to the Website or Service, or
                      any computer systems or networks connected to the Website or
                      Service.
                    </p>
                    <p className="mb-[10px]">
                      • To upload, transmit, or store any content that is
                      unlawful, harassing, defamatory, obscene, or otherwise
                      objectionable.
                    </p>
                    <p className="mb-[10px]">• To violate any applicable laws or regulations.</p>
                  </div>
                </div>
                <p className="mb-[10px]">
                  <strong>3. User Content</strong>
                </p>
                <div>
                  <p className="mb-[10px]">
                    You are solely responsible for any content you upload,
                    transmit, or store on the Website or Service.
                  </p>
                  <p className="mb-[10px]">
                    You grant CurePointOPD&nbsp; Company a non-exclusive,
                    royalty-free license to use, reproduce, modify, publish, and
                    distribute your User Content in connection with the Website
                    and Service.
                  </p>
                </div>
                <p className="mb-[10px]">
                  <strong>4. Intellectual Property</strong>
                </p>
                <div>
                  <p className="mb-[10px]">
                    The Website and Service, including all Content, are protected
                    by copyright, trademark, and other intellectual property laws.
                  </p>
                  <p className="mb-[10px]">
                    You agree not to remove, alter, or obscure any copyright
                    notices or other proprietary notices placed on the Website or
                    Service.
                  </p>
                </div>
                <p className="mb-[10px]">
                  <strong>5. Disclaimers</strong>
                </p>
                <div>
                  <p className="mb-[10px]">
                    THE WEBSITE AND SERVICE ARE PROVIDED “AS IS” AND WITHOUT
                    WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED. CUREPOINT 
                    OPD DISCLAIMS ALL WARRANTIES, INCLUDING, BUT NOT LIMITED
                    TO, THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
                    PARTICULAR PURPOSE, AND NON-INFRINGEMENT.
                  </p>
                  <p className="mb-[10px]">
                    CurePointOPD DOES NOT WARRANT THAT THE WEBSITE OR SERVICE WILL
                    BE UNINTERRUPTED OR ERROR-FREE, THAT DEFECTS WILL BE
                    CORRECTED, OR THAT THE WEBSITE OR SERVICE IS FREE OF VIRUSES
                    OR OTHER HARMFUL COMPONENTS.
                  </p>
                </div>
                <p className="mb-[10px]">
                  <strong>6. Limitation of Liability</strong>
                </p>
                <div>
                  <p className="mb-[10px]">
                    CurePointOPD SHALL NOT BE LIABLE FOR ANY DIRECT, INDIRECT,
                    INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES
                    ARISING OUT OF OR IN CONNECTION WITH YOUR USE OF THE WEBSITE
                    OR SERVICE.
                  </p>
                </div>
                <p className="mb-[10px]">
                  <strong>7. Term and Termination</strong>
                </p>
                <div>
                  <p className="mb-[10px]">
                    These Terms shall remain in full force and effect until
                    terminated by you or CurePointOPD.
                  </p>
                  <p className="mb-[10px]">
                    CurePointOPD may terminate these Terms at any time, with or
                    without cause, upon written notice to you.
                  </p>
                  <p className="mb-[10px]">
                    You may terminate these Terms by discontinuing your use of the
                    Website and Service.
                  </p>
                </div>
                <p className="mb-[10px]">
                  <strong>8. Governing Law</strong>
                </p>
                <div>
                  <p className="mb-[10px]">
                    These Terms shall be governed by and construed in accordance
                    with the laws of India.
                  </p>
                </div>
                <p className="mb-[10px]">
                  <strong>9. Entire Agreement</strong>
                </p>
                <div>
                  <p className="mb-[10px]">
                    These Terms constitute the entire agreement between you and
                    CurePointOPD with respect to the use of the Website and
                    Service.
                  </p>
                </div>
                <p className="mb-[10px]">
                  <strong>10. Severability</strong>
                </p>
                <div>
                  <p className="mb-[10px]">
                    If any provision of these Terms is held to be invalid or
                    unenforceable, such provision shall be struck and the
                    remaining provisions shall remain in full force and effect.
                  </p>
                </div>
                <p className="mb-[10px]">
                  <strong>11. Waiver</strong>
                </p>
                <div>
                  <p className="mb-[10px]">
                    No waiver of any provision of these Terms shall be deemed a
                    further or continuing waiver of such provision or any other
                    provision.
                  </p>
                </div>
                <p className="mb-[10px]">
                  <strong>12. Update to Terms</strong>
                </p>
                <div>
                  <p className="mb-[10px]">
                    CurePointOPD may update these Terms at any time by posting the
                    amended terms on the Website. Your continued use of the
                    Website or Service following the posting of amended Terms
                    constitutes your acceptance of the amended Terms.
                  </p>
                </div>
                <p className="mb-[10px]">
                  <strong>13. Contact Us</strong>
                </p>
                <p className="mb-[10px]">
                  If you have any questions about these Terms, please contact us
                  at care@curepointopd.in.
                </p>
                <p className="mb-[10px]">
                  <strong>14. For Group Insurance and Personal Accident Rider</strong>
                </p>
                <p className="mb-[10px]">
                  Age limit will be 18-65 years only for primary holder
                </p>
                <p className="mb-[10px]">
                  <strong>15. For OPD Wellness Benefits</strong>
                </p>
                <p className="mb-[10px]">
                  Age limit will be 0-85 years
                </p>
              </div>
            </div>
          </div>
          <div className="shape-1 absolute left-40 top-96 z-10">
            <img src="assets/images/home-four/shape-1.webp" alt="" />
          </div>
          <div className="shape-2 absolute right-96 top-96 z-10">
            <img src="assets/images/home-four/shape-2.webp" alt="" />
          </div>
          <div className="shape-3 absolute left-96 top-[550px] z-10">
            <img src="assets/images/home-four/shape-3.webp" alt="" />
          </div>
          <div className="shape-4 absolute right-96 top-[550px] z-10">
            <img src="assets/images/home-four/shape-4.webp" alt="" />
          </div>
        </div>
      </section>
    </>

  );
};

export default TermofUse;
